import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";

const SEO = ({ title, shortTitle, description, keywords }) => (
  <Helmet>
    <html lang="en" />
    <meta name="description" content={description} />
    <meta name="keywords" content={keywords} />
    <title>{title}</title>
    <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
    <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
    <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
    <link rel="manifest" href="/site.webmanifest" />
    <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#ff0000" />
    <link rel="shortcut icon" href="/favicon.ico" />
    <meta name="apple-mobile-web-app-title" content={shortTitle} />
    <meta name="application-name" content={shortTitle} />
    <meta name="msapplication-TileColor" content="#ffffff" />
    <meta name="msapplication-config" content="/browserconfig.xml" />
    <meta name="theme-color" content="#222020" />
  </Helmet>
);

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  keywords: PropTypes.string
};

SEO.defaultProps = {
  title: `Site Title`,
  description: `Site description.`
};

export default SEO;



// WEBPACK FOOTER //
// ./src/containers/Layout/SEO.js